import React, { Component } from 'react';
import DocumentTitle from "react-document-title";
import BsyDashboardMenu from "../dashboard/BsyDashboardMenu";
import './index.css'
import { NavLink } from "react-router-dom";
import { setPageTitle } from '../../utils/setPageTitle';

class BsyWebhookApi extends Component {

    constructor(props) {
        super(props);
        this.state = {
            apiDocList: {},
            type: "app"
        }
    }

    componentDidMount() {
        this.loadAppList()
    }

    loadAppList = () => {
        React.axios("/webapi/doclist", {}).then((res) => {
            this.setState({
                apiDocList: res.data
            })
        })
    }

    leftTitle = () => {
        return <div className="leftTitle">
            <span>{React.language('open.platform')}</span>
        </div>
    }

    dashboardMenuCenterMenu = () => {
        return <div className="open-header">
            <NavLink activeClassName="select" className="api-webhook" to={window.rootDirectroy + "/open/api"}>
                <div className="header-btn"><span>api</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="key-webhook" to={window.rootDirectroy + "/open/key"}>
                <div className="header-btn"><span>{React.language('key.management')}</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="form-webhook" to={window.rootDirectroy + "/open/webhook"}>
                <div className="header-btn"><span>webhook</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="modules-webhook" to={window.rootDirectroy + "/open/modules"}>
                <div className="header-btn"><span>{React.language('module')}</span></div>
            </NavLink>
            {window.FX.STATIC["user_corps"]["mode"] === "common" && <NavLink activeClassName="select" className="sso-webhook" to={window.rootDirectroy + "/open/sso"}>
                <div className="header-btn"><span>{React.language('account.signin.sso')}</span></div>
            </NavLink>}
        </div>
    }

    switchType = (type) => {
        return () => {
            this.setState({
                type: type
            })
        }
    }

    render() {
        const { apiDocList, type } = this.state;
        setPageTitle("开放平台 - webAPI");
        return (

            <div className="BsyWebhookApi">
                <BsyDashboardMenu dashboardMenuCenterMenu={this.dashboardMenuCenterMenu}
                    leftTitle={this.leftTitle} />
                <div className="apiCont">
                    <div className="apiMenu">
                        <div onClick={this.switchType("app")} className={type === "app" ? "menu-item select" : "menu-item"}>
                            {React.language('application.system')}
                        </div>
                        <div onClick={this.switchType("corp")} className={type === "corp" ? "menu-item select" : "menu-item"}>
                            {React.language('address.book.system')}
                        </div>
                        <div onClick={this.switchType("platform")} className={type === "platform" ? "menu-item select" : "menu-item"}>
                            {React.language('platform.system')}
                        </div>
                    </div>
                    <div className="apiApp">
                        <div className="apiTitle">
                            <h1>{React.language('api.doc')}</h1>
                            <h2 dangerouslySetInnerHTML={{ __html: React.language('api.desc', { doc: `<a href=${window._bby_config.help_link + "md/1003"} target=\"_blank\">${React.language('api.doc')}</a>` }) }} />
                        </div>
                        {apiDocList[type] && <div className="app-list">
                            {
                                type === "app" ? apiDocList[type].map((res) => {
                                    return <div className="appGroup">
                                        <div className="group-title">
                                            {res.name}
                                        </div>
                                        <div className="group-app-list">
                                            {
                                                res.apps.length > 0 ? res.apps.map(res1 => {
                                                    return <a className={"app-item line-" + res1.style.color}
                                                        href={window.rootDirectroy + "/webapi/docinfo/" + type + "/" + res1._id + "/overview"}
                                                        target="_blank">
                                                        <div className="app-view">
                                                            <div className="app-icon">
                                                                <div
                                                                    className={"icon-backgroup color-cover-" + res1.style.color}>
                                                                    <div
                                                                        className={"imgbg-bby-app imgbg-bby-app-" + res1.style.icon} />
                                                                </div>
                                                            </div>
                                                            <div className="app-title" title={res1.name}>
                                                                {res1.name}
                                                            </div>
                                                        </div>
                                                        <div className="app-bottom">

                                                        </div>
                                                        <div className="app-goto">
                                                            <i className="icon-bsy-enter" />
                                                        </div>
                                                    </a>
                                                }) : <div className="group-app-empty">
                                                    {React.language('app.store.list.empty')}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }) : apiDocList[type].map((res) => {
                                    return <a className={"app-item api-line-" + res.style.color} href={window.rootDirectroy + "/webapi/docinfo/" + type + "/" + res._id + "/overview"}
                                        target="_blank">
                                        <div className="app-view">
                                            <div className="app-icon">
                                                <i className={"icon-bsy-api-" + res.style.icon + " api-color-" + res.style.color} />
                                            </div>
                                            <div className="app-title" title={res.name}>
                                                {res.name}
                                            </div>
                                        </div>
                                        <div className="app-bottom">

                                        </div>
                                        <div className="app-goto">
                                            <i className="icon-bsy-enter" />
                                        </div>
                                    </a>
                                })
                            }
                        </div>}
                    </div>
                </div>
            </div>

        );
    }
}

export default BsyWebhookApi;